<template>
    <div class="jewelry-card">
        <a :href="result.detailPage">
            <img :src="result.picture.src" :alt="result.picture.alt" class="jewelry-card__image">
        </a>

        <div class="jewelry-card__footer">
            <span class="jewelry-card__date">{{result.date}}</span>
            <a :href="result.detailPage" class="jewelry-card__name" v-html="result.name"></a>
            <span class="jewelry-card__text">
                <span v-for="item in result.tags">#{{item}}</span>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'jewelry-card',
        selector: '.jewelry-card',
        props: {
            result: {
                type: Object,
                default: () => ({
                    picture: {
                        src: '/local/templates/love-you/images/front-end/bestsellers.png',
                        alt: 'bestsellers'
                    },
                    date: '10 червня 2020',
                    name: 'Оновлення колекцій ювелірного дому Love You',
                    text: '#новинки #мода',
                    detailPage: 'javascript: void(0)'
                })
            }
        },
        data(){
            return {
                name: 'LOVE YOU - рекламна кампанія &quot;Слухай сердце&quot;'
            }
        },
        mounted() {
            // console.log(this.result);
        }
    }
</script>

<style lang="scss">
    .jewelry-card{
        text-align: center;
        background-color: #fff;
        height: 100%;
        &__image {
            display: block;
            max-width: 100%;
            margin-left: auto;
            margin-right: auto;
        }
        &__footer{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 16px;
            @include point-lg{
                padding: 24px;
            }
        }
        &__date{
            font-size: rem(14);
            color: #757575;
            margin-bottom: 16px;
            @include point-md{
                margin-bottom: 4px;
            }
        }
        &__name{
            font-weight: 500;
            font-size: rem(16);
            color: var(--text-colour-primary);
            margin-bottom: 25px;
            @include point-md{
                font-size: rem(18);
                margin-bottom: 16px;
            }
        }
        &__text{
            font-weight: 500;
            font-size: rem(10);
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: var(--text-colour-secondary);
            @include point-md{
                font-size: rem(12);
            }
        }
    }
</style>